<template>
    <v-app id="inspire">
      
      <v-app-bar flat>
        <v-container fluid class="fill-height overlaps">
          <v-avatar
            class="me-10 ms-4"
            color="grey-darken-1"
            size="32"            
          >
          <img :src="require('@/assets/logo.png')" alt="图片的描述">
        </v-avatar>
  
          <v-btn
            v-for="link in links"
            :key="link.name"
            variant="text"
            @click="naviToComponent(link)"
            :color="selectedLink === link.name ? 'primary' : ''"
          >
            {{ link.name }}
          </v-btn>
  
          <v-spacer></v-spacer>
  
          <v-responsive max-width="260">
            <v-text-field
              density="compact"
              hide-details
              variant="solo"
            >
            你好，{{ phoneNumber }}
          </v-text-field>      
          </v-responsive>
          
          <v-btn 
            variant="outlined"
            color="primary"
            size="small"
            @click="openExportHistoryDialog"
            class="me-2"
          >
            切片历史
          </v-btn>
          
          <v-btn text 
          color="primary"
          @click="logout">
            退出
          </v-btn>
        </v-container>
      </v-app-bar>
  
      
      <v-main class="bg-grey-lighten-3">
        <v-container fluid class="pa-2">
          <v-sheet
            rounded="lg"
          >
          <router-view></router-view>
            <!--  -->
          </v-sheet>
        </v-container>
      </v-main>

      <!-- 切片历史弹窗 -->
      <v-dialog v-model="exportHistoryDialog" max-width="800">
        <v-card>
          <v-card-title class="text-h6 d-flex align-center">
            切片历史记录
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchQuery"
              append-inner-icon="mdi-magnify"
              placeholder="搜索商品名称、备注..."
              density="compact"
              variant="outlined"
              hide-details
              style="max-width: 250px;"
              class="me-4"
              @keyup.enter="handleSearch"
              clearable
              @click:clear="handleSearch"
            ></v-text-field>
            <v-btn icon @click="exportHistoryDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-text>
            <v-progress-linear v-if="loadingHistory" indeterminate color="primary"></v-progress-linear>
            
            <div v-if="!loadingHistory && exportHistory.length === 0" class="text-center py-4">
              <v-icon size="64" color="grey">mdi-file-outline</v-icon>
              <div class="text-grey mt-2">暂无导出记录</div>
            </div>
            
            <v-list v-if="!loadingHistory && exportHistory.length > 0" class="bg-transparent pa-0">
              <v-list-item
                v-for="(item, index) in exportHistory"
                :key="index"
                class="history-item mb-4 pa-4"
                rounded="lg"
              >
                <template v-slot:prepend>
                  <div class="video-icon-wrapper me-4">
                    <v-icon color="primary" size="24">mdi-video</v-icon>
                  </div>
                </template>
                
                <v-list-item-title class="d-flex align-center mb-1">
                  <v-chip 
                    :color="getStatusColor(item)" 
                    size="small" 
                    variant="flat"
                    class="me-3 font-weight-bold"
                  >
                    {{ getStatusText(item) }}
                  </v-chip>
                  <span class="text-subtitle-2 text-grey-darken-1">{{ item.commit_ts }}</span>
                </v-list-item-title>
                
                <v-list-item-subtitle class="text-wrap mt-2 py-1" v-if="item.remark || item.commodity_name">
                  <div class="d-flex flex-wrap align-center" style="gap: 8px;">
                    <template v-if="item.commodity_name">
                      <div class="commodity-tag">
                        <v-icon size="14" class="me-1">mdi-tag</v-icon>
                        <span v-html="highlightText(item.commodity_name, searchQuery)"></span>
                      </div>
                    </template>
                    <template v-if="item.remark">
                      <div class="remark-tag">
                        <v-icon size="14" class="me-1">mdi-comment-text-outline</v-icon>
                        <span v-html="highlightText(item.remark, searchQuery)"></span>
                      </div>
                    </template>
                  </div>
                </v-list-item-subtitle>

                <div class="mt-2 preview-text">
                  <v-icon size="14" color="grey-lighten-1" class="me-1">mdi-format-quote-open</v-icon>
                  <span class="text-truncate">{{ item.text || '无内容' }}</span>
                </div>
                
                <template v-slot:append>
                  <div class="d-flex align-center">
                    <v-btn
                      v-if="item.status === 'completed'"
                      color="success"
                      variant="tonal"
                      size="small"
                      class="me-2 action-btn"
                      @click="restoreToPool(item)"
                      :loading="item.loadingRestore"
                    >
                      <v-icon start size="18">mdi-plus-box</v-icon>
                      入池
                    </v-btn>
                    <v-btn
                      v-if="item.file_url"
                      color="primary"
                      variant="flat"
                      size="small"
                      class="action-btn"
                      @click="downloadFile(item.file_url, item.slice_key_path)"
                    >
                      <v-icon start size="18">mdi-download</v-icon>
                      下载
                    </v-btn>
                    <v-chip v-else color="grey-lighten-3" text-color="grey" size="small" variant="flat">
                      未同步
                    </v-chip>
                  </div>
                </template>
              </v-list-item>
            </v-list>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="exportHistoryDialog = false">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
  </template>
  
  <script setup>
  import { BASE_URL } from '@/config';
  import MessageUtil from '@/utils/MessageUtil';
import axios from 'axios';
import { ref, onMounted, computed } from 'vue'
import {useRouter, useRoute} from 'vue-router'
import {useStore} from 'vuex'
import { get_recent_user_slices, get_slice_details } from '@/services/api.js'
  
  var all_pages=[
                {name: '直播记录', path:'/clipper/live/'},
                {name: '制作切片', path:'/clipper/kol/'},
                {name: '高级搜索', path:'/clipper/search'},
                {name: '口播快剪', path:'/clipper/upload'},
                {name: '多源混剪', path:'/clipper/multi'},
                {name: '服饰识别', path:'/clipper/clothing-timeline'}
              ]

  const links = ref(all_pages )

  const selectedLink = ref(null)

  // 切片历史相关数据
  const exportHistoryDialog = ref(false)
  const exportHistory = ref([])
  const loadingHistory = ref(false)
  const searchQuery = ref('')

  const router = useRouter()
  const route = useRoute()
  
  
  const naviToComponent = (component) => {
    selectedLink.value = component.name
    router.replace(component.path)
    // currentComponent.value = component
  }


  const logout = () => {
    store.dispatch('logout')
    // localStorage.removeItem('access_token')
    // localStorage.removeItem('user')
    router.push('/login/')
  }

  // 切片历史相关方法
  const openExportHistoryDialog = async () => {
    exportHistoryDialog.value = true
    searchQuery.value = '' // 打开时重置搜索
    await loadExportHistory()
  }

  const loadExportHistory = async (search = '') => {
    loadingHistory.value = true
    try {
      const response = await get_recent_user_slices({ search })
      exportHistory.value = (response || []).map(item => ({...item, loadingRestore: false}))
    } catch (error) {
      console.error('获取切片历史失败:', error)
      alert('获取切片历史失败，请稍后重试')
      exportHistory.value = []
    } finally {
      loadingHistory.value = false
    }
  }

  const handleSearch = () => {
    loadExportHistory(searchQuery.value)
  }

  const restoreToPool = async (item) => {
    item.loadingRestore = true
    try {
      const response = await get_slice_details(item.slice_id)
      const details = response
      
      let groupsToRestore = []
      
      if (details.edited_content) {
        if (details.edited_content.segments) {
          // 多源混剪格式 (ClipGroup)
          // 移除已经不兼容的数据字段
          const group = details.edited_content
          groupsToRestore = [group]
        } else if (Array.isArray(details.edited_content)) {
          // 单个视频精剪格式 (List[WordSpan])
          groupsToRestore = [{
            id: Date.now().toString(),
            name: details.remark || item.remark || '从历史恢复',
            segments: [{
              video_id: details.video_id,
              transcription_id: details.transcription_id,
              words: details.edited_content
            }]
          }]
        }
      }
      
      if (groupsToRestore.length > 0) {
        // 先检查是否有重复的 ID（虽然 uuid 概率极低，但增加健壮性）
        for (const group of groupsToRestore) {
          // 确保 ID 存在且唯一
          if (!group.id) group.id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
          
          store.commit('multiClipper/ADD_GROUP', group)
        }
        MessageUtil.success('已成功恢复到剪辑池，点击“精剪”可查看详情')
        exportHistoryDialog.value = false
        // 跳转到多源混剪
        router.push('/clipper/multi')
      } else {
        alert('无法解析切片内容')
      }
    } catch (error) {
      console.error('恢复失败:', error)
      MessageUtil.handleApiError(error, '恢复切片失败')
    } finally {
      item.loadingRestore = false
    }
  }

  const getStatusText = (item) => {
    return item.finish_ts ? '已完成' : '进行中'
  }

  const getStatusColor = (item) => {
    return item.finish_ts ? 'success' : 'warning'
  }

  const getPreviewText = (text) => {
    if (!text) return '无内容'
    return text.length > 50 ? text.substring(0, 50) + '...' : text
  }

  const highlightText = (text, query) => {
    if (!query || !text) return text
    // 基础转义
    const safeText = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const re = new RegExp(`(${query})`, 'gi')
    return safeText.replace(re, '<span class="highlight-match">$1</span>')
  }

  const formatDate = (dateString) => {
    if (!dateString) return '未知时间'
    try {
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    } catch (error) {
      return '未知时间'
    }
  }

  const downloadFile = (fileUrl, filename) => {
    if (!fileUrl) {
      alert('文件不可用')
      return
    }
    
    try {
      const link = document.createElement('a')
      link.href = fileUrl
      link.download = filename || '下载文件'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('下载失败:', error)
      // 如果下载失败，尝试在新窗口打开
      window.open(fileUrl, '_blank')
    }
  }

  // onMounted(() => {
  //   router.replace('kol')
  //   // router.appendChild('kol')
  // })

  const store = useStore()

  // 从localStorage.getItem('user')中获取用户信息
  const phoneNumber = computed(() => {    
    let user = JSON.parse(localStorage.getItem('user'))
    if (user && user.phoneNumber) {
      let covered_phone =  user.phoneNumber
      return covered_phone.slice(0,3)+'****'+covered_phone.slice(7,11)
    } else {
      return '未知用户'
    }    
  })

  // 从服务端取得用户的可访问页面
  axios.get(BASE_URL+'user/me')
  .then(response => {
    
    // 先记一下客户端所有支持的页面的名称和路径，及对应的服务端权限名称。按照这个顺序排列
    var all_pages=[
      {name: '直播记录', path:'/clipper/live/', permission: '素材生成'},
      {name: '制作切片', path:'/clipper/kol/', permission: '达人切片'},
      {name: '高级搜索', path:'/clipper/search', permission: '达人切片'},
      {name: '口播快剪', path:'/clipper/upload', permission: '口播快剪'},
      {name: '多源混剪', path:'/clipper/multi', permission: '多源混剪'},
      {name: '服饰识别', path:'/clipper/clothing-timeline', permission: '服饰识别'}
    ]

    // 根据服务端返回的response.data.pages决定all_pages哪些可以展示
    var new_pages = all_pages.filter(page => response.pages.includes(page.permission));

    links.value = new_pages    

    // 只有在根路径或clipper根路径时才自动跳转
    if (route.path === '/' || route.path === '/clipper' || route.path === '/clipper/') {
      if (links.value.length > 0) {
        // 如果用户有多源混剪权限，优先跳转多源混剪
        const multiLink = links.value.find(link => link.name === '多源混剪')
        if (multiLink) {
          naviToComponent(multiLink)
        } else {
          // 否则默认跳转制作切片
          const kolLink = links.value.find(link => link.name === '制作切片')
          naviToComponent(kolLink || links.value[0])
        }
      }
    } else {
      // 如果已经有特定路由，尝试高亮对应的菜单项
      const matchedLink = links.value.find(link => route.path.includes(link.path) || link.path.includes(route.path))
      if (matchedLink) {
        selectedLink.value = matchedLink.name
      }
    }
  })
  .catch(error => {
    MessageUtil.handleApiError(error, '获取用户可访问页面失败')
    console.log(error)
  })
  
  onMounted(() => {
    // 页面加载时的路由跳转逻辑已移至获取权限后的回调中，避免异步请求带来的时序问题
  })

  
  
    
  </script>
  
  
  
  <style scoped>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 00px;
  }

  .history-item {
    border: 1px solid #eef0f2;
    background-color: #fff;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  }

  .history-item:hover {
    border-color: #d1d9e0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    transform: translateY(-1px);
    background-color: #fafafa;
  }

  .video-icon-wrapper {
    background-color: #f0f7ff;
    padding: 10px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .commodity-tag {
    background-color: #f3e5f5;
    color: #7b1fa2;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    border: 1px solid #e1bee7;
  }

  .remark-tag {
    background-color: #e3f2fd;
    color: #1976d2;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    border: 1px solid #bbdefb;
  }

  .preview-text {
    font-size: 13px;
    color: #4a5568 !important;
    background-color: #f8fafc;
    padding: 8px 12px;
    border-radius: 6px;
    font-style: italic;
    display: flex;
    align-items: center;
    max-width: 100%;
  }

  .preview-text span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }

  :deep(.highlight-match) {
    color: #d32f2f;
    background-color: rgba(211, 47, 47, 0.1);
    font-weight: bold;
    border-radius: 2px;
    padding: 0 2px;
  }

  .action-btn {
    text-transform: none;
    letter-spacing: 0.5px;
    font-weight: 600;
    border-radius: 8px;
  }

  /* 覆盖 Vuetify 默认样式以减少间挤感 */
  :deep(.v-list-item__append) {
    padding-left: 20px;
  }
  </style>
  